export const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' }
];

export const SCHEMA_TYPES = {
  ARRAY: 'array',
  STRING: 'string',
  NUMBER: 'number',
  INTEGER: 'integer',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATE_TIME: 'date-time'
};

export const SCHEMA_FORMATS = {
  DATE: 'date',
  DATE_TIME: 'date-time'
};
